import { render, staticRenderFns } from "./MarkdownFormItem.vue?vue&type=template&id=3eb41a91&"
import script from "./MarkdownFormItem.vue?vue&type=script&lang=js&"
export * from "./MarkdownFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports